export enum WebSocketsRoomTypes {
    Workflow = 'workflow',
    DataCheckin = 'data-checkin',
    User = 'user',
}
